<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>资金与积分账户</h1>
        <p>这里汇总待确认的代金券、提现和结算。可提现余额、冻结金额和算力成本还没有按渠道拆开的账户台账。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">待确认到账的券</div><div class="v">{{ payRows.length }}</div><div class="s">面值 ¥ {{ yuan(sumFace(payRows)) }}</div></div>
      <div class="ch-metric"><div class="k">待审批的券</div><div class="v">{{ reviewRows.length }}</div><div class="s">面值 ¥ {{ yuan(sumFace(reviewRows)) }}</div></div>
      <div class="ch-metric"><div class="k">提现单</div><div class="v">{{ withdrawals.length }}</div><div class="s">打款在分账结算里核验发票后操作</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-tabs">
        <button type="button" :class="{ on: tab === 'pay' }" @click="tab = 'pay'">购买待确认</button>
        <button type="button" :class="{ on: tab === 'review' }" @click="tab = 'review'">申请待审批</button>
        <button type="button" :class="{ on: tab === 'withdraw' }" @click="tab = 'withdraw'">提现</button>
      </div>
      <table v-if="tab !== 'withdraw'" class="ch-table">
        <thead><tr><th>渠道</th><th>面值</th><th>应付</th><th>来源</th><th>状态</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in current" :key="row.id">
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>¥ {{ yuan(row.faceValue) }}</td>
            <td>{{ row.payAmount != null ? '¥ ' + yuan(row.payAmount) : '—' }}</td>
            <td>{{ statusName(row.source) }}</td>
            <td><span class="ch-tag warn">{{ statusName(row.status) }}</span></td>
            <td>
              <button v-if="row.status === 'PENDING_PAY'" class="ch-link" type="button" @click="act(row, 'confirmPay')">确认到账</button>
              <button v-if="row.status === 'PENDING_REVIEW'" class="ch-link" type="button" @click="act(row, 'approve')">发放</button>
              <button class="ch-link" type="button" @click="act(row, 'reject')">驳回</button>
            </td>
          </tr>
          <tr v-if="!current.length"><td colspan="6" class="ch-empty">没有待处理的券</td></tr>
        </tbody>
      </table>
      <table v-else class="ch-table">
        <thead><tr><th>时间</th><th>渠道</th><th>金额</th><th>发票</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in withdrawals" :key="row.id">
            <td>{{ row.createdAt }}</td>
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>¥ {{ yuan(row.amount) }}</td>
            <td>{{ row.invoiceUrl || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 'PAID' ? 'ok' : 'warn'">{{ statusName(row.status) }}</span></td>
          </tr>
          <tr v-if="!withdrawals.length"><td colspan="5" class="ch-empty">还没有提现</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners, getChannelVouchers, getChannelWithdrawals, reviewChannelVoucher } from '@/api/admin'
import { statusName, yuan } from '../partner/labels'
import { partnerName } from './lookup'

export default {
  name: 'HqWallet',
  data() { return { tab: 'pay', partners: [], vouchers: [], withdrawals: [] } },
  computed: {
    payRows() { return this.vouchers.filter(item => item.status === 'PENDING_PAY') },
    reviewRows() { return this.vouchers.filter(item => item.status === 'PENDING_REVIEW') },
    current() { return this.tab === 'review' ? this.reviewRows : this.payRows }
  },
  created() { this.load() },
  methods: {
    statusName, yuan,
    nameOf(id) { return partnerName(this.partners, id) },
    sumFace(rows) { return rows.reduce((n, item) => n + Number(item.faceValue || 0), 0) },
    async load() {
      const partners = await getChannelPartners()
      const vouchers = await getChannelVouchers()
      const withdrawals = await getChannelWithdrawals()
      this.partners = partners.list || []
      this.vouchers = vouchers.list || []
      this.withdrawals = withdrawals.list || []
    },
    async act(row, action) {
      const body = { action }
      if (action === 'reject') {
        let input
        try {
          input = await this.$prompt('驳回原因', '驳回', { inputPlaceholder: '请填写驳回原因，渠道商可以看到', inputValidator: value => (value && value.trim() ? true : '请填写驳回原因') })
        } catch (e) {
          return
        }
        body.reason = input.value.trim()
      }
      await reviewChannelVoucher(row.id, body)
      this.$message.success('已处理')
      this.load()
    }
  }
}
</script>
